import { z } from 'zod';
import { socialVideoFormatSchema } from '../social-video-format-schema';

export const saveSocialClipSelectionV1RequestSchema = z.object({
  format: socialVideoFormatSchema.optional().default('vertical'),
  selectedClipIds: z.array(z.number()),
});

export type ISaveSocialClipSelectionV1Request = z.infer<
  typeof saveSocialClipSelectionV1RequestSchema
>;
